<template>
<div>
  <div class="page-header">
          <div class="row justify-content-end">
            <div class="col-10 text-left">
              <h2 class="page-title">{{$t('registration.tabs.tabContactDetails')}}</h2>
            </div>
            <div class="col-2 lighten text-right">
              <h2 class="page-title">34%</h2>
            </div>
          </div>
        </div>
   <form class="row justify-content-center" action="POST" v-on:submit.prevent="validateInput('Contactform')" data-vv-scope="Contactform">
      <div class="col-12">
         <div class="form-group custom-input">
            <div class="para">{{$t('candidateProfile.contactDetails.lblCorrespondenceAddressPIN')}}</div>
            <input max="6" maxlength="6" oninput="this.value=this.value.slice(0,this.maxLength||1/1);this.value=(this.value   < 0) ? (1/1) : this.value;" name="Correspondence Address PIN" class="form-control-alt col-2" id="correspondence" v-model="contactDetails.corespondenecePin" v-validate="'required|regex:^([0-9]{6})$|numeric'" :class="{'form-error': errors.has('Contactform.Correspondence Address PIN'),'input': true, 'is-danger': errors.has('Contactform.Correspondence Address PIN') }" type="number" :placeholder="$t('candidateProfile.contactDetails.plceAddressPIN')" v-on:keyup="correspondanceTehsilPinObj = null;pinCodeChanged(contactDetails.corespondenecePin,'Correspondence')" >
            <sup>
            <i class="mdi mdi-star text-danger"></i>
            </sup>
            <span v-if="showCorrespondenceTalukaList">
              <div class="para">{{$t('candidateProfile.contactDetails.lblCorrespondancetehsilDistrictState')}}</div>
                  <v-select label="displayField"  :class="{'form-error': errors.has('correspondanceTehsil')}" v-model="correspondanceTehsilPinObj" :options="uniqueCorrespondanceAddressList" :error-messages="errors.collect('correspondanceTehsil')" v-validate="'required|not_in:Select'" data-vv-name="correspondanceTehsil" name="correspondanceTehsil" placeholder="Tehsil-District-State"  required></v-select>
                  <sup>
                  <i class="mdi mdi-star text-danger"></i>
                  </sup>
            </span>
            <i v-show="errors.has('Contactform.Correspondence Address PIN')" class="fa fa-warning"></i>
            <div class="para">{{$t('candidateProfile.contactDetails.lblPermanentAddressPIN')}}</div>
             <input max="6" maxlength="6" oninput="this.value=this.value.slice(0,this.maxLength||1/1);this.value=(this.value   < 0) ? (1/1) : this.value;" name="Permanent Address PIN" class="form-control-alt col-2" id="permanent" v-model="contactDetails.permanentPin" v-validate="'required|regex:^([0-9]{6})$|numeric'" :class="{'form-error': errors.has('Contactform.Permanent Address PIN'),'input': true, 'is-danger': errors.has('Contactform.Permanent Address PIN') }" type="number" :placeholder="$t('candidateProfile.contactDetails.plceAddressPIN')" v-on:keyup="permanentTehsilPinObj = null;pinCodeChanged(contactDetails.permanentPin,'Permanent')">
            <sup>
            <i class="mdi mdi-star text-danger"></i>
            </sup>
            <span v-if="showPermanentTalukaList">
              <div class="para">{{$t('candidateProfile.contactDetails.lblPermanenttehsilDistrictState')}}</div>
                  <v-select label="displayField"  :class="{'form-error': errors.has('tehsil')}" v-model="permanentTehsilPinObj" :options="uniquePermanentAddressList" :error-messages="errors.collect('tehsil')" v-validate="'required|not_in:Select'" data-vv-name="tehsil" name="tehsil" placeholder="Tehsil-District-State"  required></v-select>
                  <sup>
                  <i class="mdi mdi-star text-danger"></i>
                  </sup>
            </span>
          </div>
          <div class="form-group custom-input">
            <p><br></p>
            <div class="para">{{$t('candidateProfile.contactDetails.lblEmailID')}}</div>
            <input name="email" :disabled="disableEmail" class="form-control-alt" id="email" v-model="contactDetails.email" v-validate="'required|email'" :class="{'form-error': errors.has('Contactform.email'),'input': true, 'is-danger': errors.has('Contactform.email') }" type="text" :placeholder="$t('candidateProfile.contactDetails.plceEmailID')">
            <sup>
            <i class="mdi mdi-star text-danger"></i>
            </sup>
            <div class="para">{{$t('candidateProfile.contactDetails.lblMobileNumber')}}</div>
            <input maxlength="10" :disabled="disableMobile" name="mobile" class="form-control-alt col-2" id="mobile" v-model="contactDetails.phoneNo" v-validate="'required|regex:^([0-9]{10})$'" :class="{'form-error': errors.has('Contactform.mobile'),'input': true, 'is-danger': errors.has('Contactform.mobile') }" type="text" :placeholder="$t('candidateProfile.contactDetails.plceMobileNumber')">
            <sup>
            <i class="mdi mdi-star text-danger"></i>
            </sup>
            <span class="pcss input-group-addon btn btn-sm" :title="$t('candidateProfile.contactDetails.tooltipSkypeID')"> {{$t('candidateProfile.contactDetails.lblSkypeID')}}
            <!-- <div class="para">{{$t('candidateProfile.contactDetails.lblSkypeID')}}</div> -->
            <input type="text" class="form-control-alt" id="skype"   v-model="contactDetails.skypeId" aria-describedby="skype" :placeholder="$t('candidateProfile.contactDetails.plceSkypeID')">
            </span>
         </div>
      </div>
   </form>
    <div class=" row text-center p-3">
        <button type="button" class="btn btn btn-info-alt mr-3" @click="prevTabFunc"> {{$t('button.back')}}</button>
        <button type="button" class="btn btn btn-orange ml-auto" @click="nextTabFunc"> {{$t('button.next')}}</button>
    </div>
   </div>
</template>
<script>
import axios from 'axios'
export default {
  name: 'Address',
  components: {},
  data () {
    return {
      contactDetails: { corespondeneceAddress: {}, permanentAddress: {} },
      aadhaarPin: '',
      permanentPinVerified: false,
      correspondancePinVerified: false,
      correspondanceTehsilPinObj: null,
      permanentTehsilPinObj: null,
      uniqueCorrespondanceAddressList: [ ],
      uniquePermanentAddressList: [ ],
      showCorrespondenceTalukaList: false,
      showPermanentTalukaList: false,
      disableEmail: false,
      disableMobile: false
    }
  },
  methods: {
    fetchUserDetails: function () {
      var self = this
      axios.get('/r/entry/getUserApplicationStatus/' + this.$store.state.candidateProfile.profileUser).then(response => {
        if (response.data !== null) {
          let profileStatus = response.data.profileStatus
          if (!profileStatus.personalDetails) {
            this.$router.push({ name: 'personalDetails' })
          } else if (!profileStatus.contactDetails) {
            this.$router.push({ name: 'address' })
          } else if (!profileStatus.educationDetails) {
            this.$router.push({ name: 'educationalDetails' })
          } else if (!profileStatus.documentDetails) {
            this.$router.push({ name: 'documentsupload' })
          } else if (!profileStatus.qualificationDetails) {
            axios.get('r/projectConfig/getAllProjectConfig')
            .then(responses => {
              if (responses.data.ocrConfig.required) {
                this.$router.push({ name: 'imageExtracter' })
              } else {
                this.$router.push({ name: 'qualificationDetails' })
              }
            })
            .catch(e => {
              console.log(e)
            })
          } else {
            this.$router.push({ name: 'profileSummary' })
          }
        }
      }).catch(e => {
        this.$toasted.error(self.$t('toastr.toastrSomethingWentWrong'), {
          theme: 'bubble',
          duration: this.TOASTR_TIME
        })
        console.error(e)
      })
    },
    nextTabFunc () {
      this.validateInput()
    },
    prevTabFunc () {
      this.$router.push('personalDetails')
    },
    pinCodeChanged (pincode, addressType) {
      if (addressType === 'Correspondence') {
        this.correspondancePinVerified = false
        this.showCorrespondenceTalukaList = false
      } else {
        this.permanentPinVerified = false
        this.showPermanentTalukaList = false
      }
      var self = this
      if (pincode.length === 6) {
        axios.get('r/candidateProfile/getAddressByPincode/' + pincode).then(Response => {
          var responseData = Response.data
          if (responseData.length === 0 && addressType === 'Correspondence') {
            this.$toasted.error(self.$t('candidateProfile.profileSummary.toastrcorrespondancePinCodeNotFound'), {
              theme: 'bubble',
              duration: this.TOASTR_TIME
            })
            return false
          } else if (responseData.length === 0 && addressType === 'Permanent') {
            this.$toasted.error(self.$t('candidateProfile.profileSummary.toastrPermanentPinCodeNotFound'), {
              theme: 'bubble',
              duration: this.TOASTR_TIME
            })
            return false
          }
          if (addressType === 'Correspondence') {
            if (responseData.length === 1) {
              this.showCorrespondenceTalukaList = false
              this.correspondanceTehsilPinObj = null
              this.contactDetails.corespondeneceAddress.tehsil = responseData[0].tehsil
              this.contactDetails.corespondeneceAddress.district = responseData[0].district
              this.contactDetails.corespondeneceAddress.state = responseData[0].state
            } else {
              this.showCorrespondenceTalukaList = true
              this.uniqueCorrespondanceAddressList = responseData
            }
          } else {
            if (responseData.length === 1) {
              this.showPermanentTalukaList = false
              this.permanentTehsilPinObj = null
              this.contactDetails.permanentAddress.tehsil = responseData[0].tehsil
              this.contactDetails.permanentAddress.district = responseData[0].district
              this.contactDetails.permanentAddress.state = responseData[0].state
            } else {
              this.showPermanentTalukaList = true
              this.uniquePermanentAddressList = responseData
            }
          }
        }).catch(e => {
          console.error(e)
          this.$toasted.error(self.$t('toastr.toastrSomethingWentWrong'), {
            theme: 'bubble',
            duration: this.TOASTR_TIME
          })
        })
      }
    },
    getData () {
      var self = this
      var userName = this.$store.state.candidateProfile.profileUser
      axios.get('r/candidateProfile/getContactDetails/' + userName).then(Response => {
        this.candidateProfile = Response.data
        this.contactDetails = JSON.parse(JSON.stringify(this.candidateProfile.contactDetails))
        if (this.contactDetails.phoneNo) {
          this.disableMobile = true
        }
        if (this.contactDetails.email) {
          this.disableEmail = true
        }
        if (this.candidateProfile.aadhaarVerified === true) {
          this.aadhaarPin = this.candidateProfile.contactDetails.permanentPin
        }
        if (this.contactDetails.corespondeneceAddress !== undefined && this.contactDetails.corespondeneceAddress !== null && this.contactDetails.corespondeneceAddress.tehsil !== '') {
          this.correspondanceTehsilPinObj = {}
          this.correspondanceTehsilPinObj.tehsil = this.contactDetails.corespondeneceAddress.tehsil
          this.correspondanceTehsilPinObj.district = this.contactDetails.corespondeneceAddress.district
          this.correspondanceTehsilPinObj.state = this.contactDetails.corespondeneceAddress.state
          this.correspondanceTehsilPinObj.displayField = this.contactDetails.corespondeneceAddress.tehsil + '-' + this.contactDetails.corespondeneceAddress.district + '-' + this.contactDetails.corespondeneceAddress.state
        }
        if (this.contactDetails.permanentAddress !== undefined && this.contactDetails.permanentAddress !== null && this.contactDetails.permanentAddress.tehsil !== '') {
          this.permanentTehsilPinObj = {}
          this.permanentTehsilPinObj.tehsil = this.contactDetails.permanentAddress.tehsil
          this.permanentTehsilPinObj.district = this.contactDetails.permanentAddress.district
          this.permanentTehsilPinObj.state = this.contactDetails.permanentAddress.state
          this.permanentTehsilPinObj.displayField = this.contactDetails.permanentAddress.tehsil + '-' + this.contactDetails.permanentAddress.district + '-' + this.contactDetails.permanentAddress.state
        }
        this.pinCodeChanged(this.contactDetails.corespondenecePin, 'Correspondence')
        this.pinCodeChanged(this.contactDetails.permanentPin, 'Permanent')
        this.correspondancePinVerified = true
        this.permanentPinVerified = true
      }).catch(e => {
        console.error(e)
        this.$toasted.error(self.$t('toastr.toastrSomethingWentWrong'), {
          theme: 'bubble',
          duration: this.TOASTR_TIME
        })
      })
    },
    validate () {
      this.$validator.validate()
      alert('Inside Validate')
    },
    // save contact details
    validateInput (scope) {
      var self = this
      return this.$validator.validate().then((result) => {
        if (result) {
          return this.validatePinCode(this.contactDetails.corespondenecePin)
        } else {
          this.$validator.validate('Contactform.Correspondence Address PIN', this.contactDetails.corespondenecePin).then((result) => {
            if (!result) {
              if (this.contactDetails.corespondenecePin === '') {
                this.$toasted.error(self.$t('candidateProfile.contactDetails.toastrEnterCorrespondanceAddress'), {
                  theme: 'bubble',
                  duration: this.TOASTR_TIME
                })
              } else {
                this.$toasted.error(self.$t('candidateProfile.contactDetails.toastrCorrespondancePinDigits'), {
                  theme: 'bubble',
                  duration: this.TOASTR_TIME
                })
              }
            }
          })
          this.$validator.validate('Contactform.Permanent Address PIN', this.contactDetails.permanentPin).then((result) => {
            if (!result) {
              if (this.contactDetails.permanentPin === '') {
                this.$toasted.error(self.$t('candidateProfile.contactDetails.toastrEnterPermanentAddress'), {
                  theme: 'bubble',
                  duration: this.TOASTR_TIME
                })
              } else {
                this.$toasted.error(self.$t('candidateProfile.contactDetails.toastrPermanentPinDigits'), {
                  theme: 'bubble',
                  duration: this.TOASTR_TIME
                })
              }
            }
          })
          this.$validator.validate('Contactform.email', this.contactDetails.email).then((result) => {
            if (!result) {
              if (this.contactDetails.email === '') {
                this.$toasted.error(self.$t('candidateProfile.contactDetails.toastrEnterEmailID'), {
                  theme: 'bubble',
                  duration: this.TOASTR_TIME
                })
              } else {
                this.$toasted.error(self.$t('candidateProfile.contactDetails.toastrInvalidEmailID'), {
                  theme: 'bubble',
                  duration: this.TOASTR_TIME
                })
              }
            }
          })
          this.$validator.validate('Contactform.mobile', this.contactDetails.phoneNo).then((result) => {
            if (!result) {
              if (this.contactDetails.phoneNo === '') {
                this.$toasted.error(self.$t('candidateProfile.contactDetails.toastrEnterMobileNumber'), {
                  theme: 'bubble',
                  duration: this.TOASTR_TIME
                })
              } else {
                this.$toasted.error(self.$t('candidateProfile.contactDetails.toastrMobileNumberDigits'), {
                  theme: 'bubble',
                  duration: this.TOASTR_TIME
                })
              }
            }
          })
          if (this.showCorrespondenceTalukaList) {
            this.$validator.validate('correspondanceTehsil', this.correspondanceTehsilPinObj).then((result) => {
              if (!result) {
                this.$toasted.error(self.$t('candidateProfile.contactDetails.toastrSelectCorrespondanceTehsil'), {
                  theme: 'bubble',
                  duration: this.TOASTR_TIME
                })
              }
            })
          }
          if (this.showPermanentTalukaList) {
            this.$validator.validate('tehsil', this.permanentTehsilPinObj).then((result) => {
              if (!result) {
                this.$toasted.error(self.$t('candidateProfile.contactDetails.toastrSelectPermanentTehsil'), {
                  theme: 'bubble',
                  duration: this.TOASTR_TIME
                })
              }
            })
          }
          return false
        }
      }).catch(e => {
        console.error(e)
        this.$toasted.error(self.$t('toastr.toastrSomethingWentWrong'), {
          theme: 'bubble',
          duration: this.TOASTR_TIME
        })
        return false
      })
    },
    saveContactDetails: function () {
      if (this.correspondanceTehsilPinObj !== null) {
        this.contactDetails.corespondeneceAddress.tehsil = this.correspondanceTehsilPinObj.tehsil
        this.contactDetails.corespondeneceAddress.district = this.correspondanceTehsilPinObj.district
        this.contactDetails.corespondeneceAddress.state = this.correspondanceTehsilPinObj.state
      }
      if (this.permanentTehsilPinObj !== null) {
        this.contactDetails.permanentAddress.tehsil = this.permanentTehsilPinObj.tehsil
        this.contactDetails.permanentAddress.district = this.permanentTehsilPinObj.district
        this.contactDetails.permanentAddress.state = this.permanentTehsilPinObj.state
      }
      if (this.aadhaarPin !== null && this.aadhaarPin !== '' && this.aadhaarPin !== this.contactDetails.permanentPin) {
        this.candidateProfile.aadhaarVerified = false
        this.candidateProfile.contactDetails = this.contactDetails
      } else {
        this.candidateProfile.contactDetails = this.contactDetails
      }
      if (this.candidateProfile.contactDetails.skypeId !== undefined && this.candidateProfile.contactDetails.skypeId !== null) {
        this.candidateProfile.contactDetails.skypeId = this.candidateProfile.contactDetails.skypeId.trim()
      }
      var self = this
      if (this.contactDetails.corespondeneceAddress.tehsil === undefined || this.contactDetails.corespondeneceAddress.tehsil === null || this.contactDetails.corespondeneceAddress.tehsil === '') {
        this.$toasted.error(self.$t('candidateProfile.contactDetails.toastrSelectCorrespondanceTehsil'), {
          theme: 'bubble',
          duration: this.TOASTR_TIME
        })
        return false
      }
      if (this.contactDetails.permanentAddress.tehsil === undefined || this.contactDetails.permanentAddress.tehsil === null || this.contactDetails.permanentAddress.tehsil === '') {
        this.$toasted.error(self.$t('candidateProfile.contactDetails.toastrSelectPermanentTehsil'), {
          theme: 'bubble',
          duration: this.TOASTR_TIME
        })
        return false
      }

      return axios
          .post('r/candidateProfile/updateContactDetails/' + this.$store.state.candidateProfile.profileUser, this.candidateProfile)
          .then(response => {
            if (response.status === 200) {
              this.$toasted.success(self.$t('toastr.toastrContactDetailsSaved'), {
                theme: 'bubble',
                duration: this.TOASTR_TIME
              })
              // this.$router.push('educationalDetails')
              this.fetchUserDetails()
              return true
            }
          })
          .catch(e => {
            console.error(e)
            this.$toasted.error(self.$t('toastr.toastrSomethingWentWrong'), {
              theme: 'bubble',
              duration: this.TOASTR_TIME
            })
            return false
          })
    },
    validatePinCode: function (pincode) {
      var self = this
      return axios.get('/r/candidateProfile/verifyPincode/' + pincode).then(response => {
        if (response.data !== null && response.data !== 'false') {
          if (this.contactDetails.corespondenecePin === pincode) {
            this.correspondancePinVerified = true
            if (this.contactDetails.corespondenecePin === this.contactDetails.permanentPin) {
              this.permanentPinVerified = true
            } else {
              if (!this.permanentPinVerified) {
                return this.validatePinCode(this.contactDetails.permanentPin)
              }
            }
          } else if (this.contactDetails.permanentPin === pincode) {
            this.permanentPinVerified = true
          }
          if (this.correspondancePinVerified && this.permanentPinVerified) {
            return this.saveContactDetails()
          }
        } else {
          if (this.contactDetails.corespondenecePin === pincode) {
            this.$toasted.error(self.$t('candidateProfile.profileSummary.toastrcorrespondancePinCodeNotFound'), {
              theme: 'bubble',
              duration: this.TOASTR_TIME
            })
          } else if (this.contactDetails.permanentPin === pincode) {
            this.$toasted.error(self.$t('candidateProfile.profileSummary.toastrPermanentPinCodeNotFound'), {
              theme: 'bubble',
              duration: this.TOASTR_TIME
            })
          }
          return false
        }
      }).catch(e => {
        this.$toasted.error(self.$t('toastr.toastrSomethingWentWrong'), {
          theme: 'bubble',
          duration: this.TOASTR_TIME
        })
        console.error(e)
        return false
      })
    }
  },
  created: function () {
    if (this.$store.state.user.userDetails.confirmStatus) {
      this.$router.push({ name: 'entry' })
    } else {
      this.getData()
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/registration/address.vue